import React, { Fragment } from 'react'
import ForgotPasswordPage from '../../Components/Auth/ForgotPasswordPage'

const ForgotPassword = () => {
    return (
        <Fragment >
            <ForgotPasswordPage />
        </Fragment>
    )
}

export default ForgotPassword